<template>
  <navbar>
    <router-link
      :to="`/spreadsheets/${id}`"
      exact-active-class="is-active"
      class="navbar-item"
    >
      Dashboard
    </router-link>
    <router-link
      :to="`/spreadsheets/${id}/expenses`"
      exact-active-class="is-active"
      class="navbar-item"
    >
      Expenses
    </router-link>
    <router-link
      :to="`/spreadsheets/${id}/investments`"
      exact-active-class="is-active"
      class="navbar-item"
    >
      Investments
    </router-link>
    <router-link
      :to="`/spreadsheets/${id}/income`"
      exact-active-class="is-active"
      class="navbar-item"
    >
      Income
    </router-link>
  </navbar>
  <section class="section">
    <div class="container">
      <progress v-if="loading" class="progress is-small">Loading...</progress>
      <router-view v-else />
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('balanceSheet');
import Navbar from './Navbar.vue';

export default {
  components: {
    Navbar,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  watch: {
    id: {
      handler: 'loadSpreadsheet',
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['load']),

    async loadSpreadsheet() {
      this.loading = true;

      try {
        await this.load(this.id);
      } catch (error) {
        this.$router.push({
          path: '/spreadsheets',
          query: {
            error: error.message,
            attempted_id: error.id,
          },
        });
      }

      this.loading = false;
    },
  },
};
</script>
